import { gql, useQuery } from "@apollo/client";
import GuideTemplatePreviewSection from "components/ModalSelectWithPreview/GuideTemplateModalSelectWithPreview/GuideTemplatePreviewSection";
import ModalSelectWithPreviewContent from "components/ModalSelectWithPreview/ModalSelectWithPreviewContent";
import {
  GuideTemplatesForSelect,
  GuideTemplatesForSelect_currentOrganization_guideTemplates as GuideTemplate,
} from "generated/schemaTypes";

const HIRING_PLANS = gql`
  query GuideTemplatesForSelect(
    $orderBy: [OrganizationGuideTemplatesOrderByInput!]
  ) {
    currentOrganization {
      id
      ...PreviewGuideOrganizationFragment
      guideTemplates(orderBy: $orderBy, where: { status: ACTIVE }) {
        id
        name
        updatedAt
        ...GuideTemplateForPreviewFragment
      }
    }
  }
  ${GuideTemplatePreviewSection.fragments.organization}
  ${GuideTemplatePreviewSection.fragments.guideTemplate}
`;

interface GuideTemplateSelectionViewProps {
  selectedGuideTemplate: GuideTemplate | null;
  setSelectedGuideTemplate: (arg: GuideTemplate | null) => void;
}

function GuideTemplateSelectionView({
  selectedGuideTemplate,
  setSelectedGuideTemplate,
}: GuideTemplateSelectionViewProps) {
  const { data, loading } = useQuery<GuideTemplatesForSelect>(HIRING_PLANS, {
    variables: {
      orderBy: [
        {
          name: "asc",
        },
      ],
    },
  });

  return (
    <ModalSelectWithPreviewContent<GuideTemplate>
      idResolver={(hiringPlan) => hiringPlan.id}
      isLoading={loading}
      menuItemTitleResolver={(hiringPlan) => hiringPlan.name}
      previewItems={data?.currentOrganization?.guideTemplates ?? []}
      renderPreviewContent={(guideTemplate) =>
        data?.currentOrganization ? (
          <GuideTemplatePreviewSection
            guideTemplate={guideTemplate}
            organization={data.currentOrganization}
          />
        ) : null
      }
      selectedItem={selectedGuideTemplate}
      setSelectedItem={setSelectedGuideTemplate}
    />
  );
}

export default GuideTemplateSelectionView;
